import type { UseSidebarCollapsed } from 'lib-knowledge-management';
import { useCallback } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

/**
 * Whether the knowledge sidebar is collapsed to its icon rail, remembered in
 * the user's server storage like the conversation sidebar's open state.
 */
export const useKnowledgeSidebarCollapsed: UseSidebarCollapsed = () => {
  const { data, set } = useServerStorage('user');
  const isCollapsed = data.knowledge?.isSidebarCollapsed ?? false;

  const setCollapsed = useCallback(
    (collapsed: boolean) =>
      set({
        knowledge: (draft) => {
          draft.isSidebarCollapsed = collapsed;
        },
      }),
    [set],
  );

  return [isCollapsed, setCollapsed];
};
